import { Typography } from 'antd'
import { CIMSPage } from '@cims-online/shared'
import ProjectLink from 'components/ProjectLink'

/**
 * @see {@link GroupFallbackProps}
 */
function GroupFallback() {
  return (
    <Typography.Paragraph>
      No{' '}
      <ProjectLink item={CIMSPage.DSDisciplines}>
        Design Submittal Disciplines
      </ProjectLink>{' '}
      have been configured for this Project
    </Typography.Paragraph>
  )
}

export default GroupFallback
